module.exports = __webpack_public_path__ + "824731819a7b1555c0591b2822ccb5ba.pdf";